(function () {
  const CONFIG = {
    lojaAntiga: "https://checkout.creewboots.com",
    lojaMyshopify: "https://xtje6u-1n.myshopify.com",
    endpointMapa: "https://ponte-checkout-production.up.railway.app/map",
    endpointRegistro: "https://ponte-checkout-production.up.railway.app/registrar-redirect",
    irDiretoParaCheckout: true,
  };
  function registrarRedirect(duracao) {
    try {
      if (!CONFIG.endpointRegistro) return;
      // Prefere o domínio permanente quando disponibilizado pelo tema Shopify.
      const shop = window.Shopify && window.Shopify.shop;
      const dominio = typeof shop === "string" && /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop)
        ? shop.toLowerCase() : location.hostname;
      const payload = JSON.stringify({
        loja_dominio: dominio,
        sucesso: true,
        duracao_ms: Math.max(0, Math.round(duracao)),
      });
      fetch(CONFIG.endpointRegistro, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        credentials: "omit",
        body: payload,
        keepalive: true,
      }).then(async (resposta) => {
        if (!resposta.ok) throw new Error("HTTP " + resposta.status);
        const dados = await resposta.json();
        if (!dados || dados.ok !== true) throw new Error("Registro não confirmado pelo servidor.");
      }).catch((erro) => console.warn("[Ponte] Registro do redirecionamento falhou:", erro.message));
    } catch (erro) {
      console.warn("[Ponte] Registro do redirecionamento falhou:", erro.message);
    }
  }
  // Feedback visual: preserva o conteúdo e os eventos originais do botão.
  let ponteOcupada = false;
  let restaurarBotaoPonte = null;
  function prepararVisualPonte(botao) {
    if (!document.getElementById('ponte-checkout-feedback-style')) {
      const estilo = document.createElement('style');
      estilo.id = 'ponte-checkout-feedback-style';
      estilo.textContent = `
        .ponte-checkout-busy{position:relative!important;cursor:progress!important;opacity:.88!important;transition:opacity .15s ease!important}
        .ponte-checkout-busy:not(input){color:transparent!important;text-shadow:none!important;-webkit-text-fill-color:transparent!important}
        .ponte-checkout-busy:not(input)>*{visibility:hidden!important}
        .ponte-checkout-busy:not(input)::before{content:attr(data-ponte-loading-label)!important;position:absolute!important;inset:0!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:0 12px 0 42px!important;margin:0!important;border:0!important;box-shadow:none!important;background:none!important;transform:none!important;opacity:1!important;visibility:visible!important;color:var(--ponte-loading-color)!important;-webkit-text-fill-color:var(--ponte-loading-color)!important;font-family:inherit!important;font-size:inherit!important;line-height:1.2!important;letter-spacing:normal!important;text-transform:none!important;white-space:normal!important;pointer-events:none!important;z-index:1!important}
        .ponte-checkout-busy:not(input)::after{content:''!important;position:absolute!important;left:16px!important;top:50%!important;right:auto!important;bottom:auto!important;width:16px!important;height:16px!important;box-sizing:border-box!important;margin:-8px 0 0!important;padding:0!important;border:2px solid var(--ponte-loading-color)!important;border-right-color:transparent!important;border-radius:50%!important;box-shadow:none!important;background:none!important;opacity:.85!important;visibility:visible!important;animation:ponte-checkout-spin .7s linear infinite!important;pointer-events:none!important;z-index:2!important}
        .ponte-checkout-live{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important}
        @keyframes ponte-checkout-spin{to{transform:rotate(360deg)}}
        @media(prefers-reduced-motion:reduce){.ponte-checkout-busy,.ponte-checkout-busy::after{animation:none!important;transition:none!important}}
      `;
      document.head.appendChild(estilo);
    }
    const idioma = ((document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'en').split(/[-_]/)[0]).toLowerCase();
    const textos = {pt:'Abrindo checkout…',en:'Opening checkout…',de:'Kasse wird geöffnet…',fr:'Ouverture du paiement…',es:'Abriendo el pago…',it:'Apertura del checkout…',nl:'Afrekenen openen…',pl:'Otwieranie płatności…',ja:'購入手続きへ…'};
    const texto = textos[idioma] || textos.en;
    let aviso = document.getElementById('ponte-checkout-live');
    if (!aviso) {
      aviso = document.createElement('span');
      aviso.id = 'ponte-checkout-live';
      aviso.className = 'ponte-checkout-live';
      aviso.setAttribute('role','status');
      aviso.setAttribute('aria-live','polite');
      document.body.appendChild(aviso);
    }
    aviso.textContent = texto;
    if (!botao || !botao.classList) return () => { aviso.textContent = ''; };
    const atributos = ['aria-busy','aria-disabled','aria-label','data-ponte-loading-label','disabled'];
    const antes = atributos.map(nome => [nome, botao.getAttribute(nome)]);
    const tinhaClasse = botao.classList.contains('ponte-checkout-busy');
    const corAnterior = botao.style.getPropertyValue('--ponte-loading-color');
    const prioridadeAnterior = botao.style.getPropertyPriority('--ponte-loading-color');
    const cor = window.getComputedStyle(botao).color;
    const valorAnterior = botao.tagName === 'INPUT' ? botao.value : null;
    botao.style.setProperty('--ponte-loading-color', cor);
    botao.setAttribute('aria-busy','true');
    botao.setAttribute('aria-disabled','true');
    botao.setAttribute('aria-label',texto);
    botao.setAttribute('data-ponte-loading-label',texto);
    if ('disabled' in botao) botao.disabled = true;
    if (botao.tagName === 'INPUT') botao.value = texto;
    botao.classList.add('ponte-checkout-busy');
    return () => {
      for (const [nome, valor] of antes) {
        if (valor === null) botao.removeAttribute(nome); else botao.setAttribute(nome,valor);
      }
      if (!tinhaClasse) botao.classList.remove('ponte-checkout-busy');
      if (corAnterior) botao.style.setProperty('--ponte-loading-color',corAnterior,prioridadeAnterior);
      else botao.style.removeProperty('--ponte-loading-color');
      if (botao.tagName === 'INPUT') botao.value = valorAnterior;
      aviso.textContent = '';
    };
  }
  function finalizarVisualPonte() {
    ponteOcupada = false;
    if (restaurarBotaoPonte) { restaurarBotaoPonte(); restaurarBotaoPonte = null; }
  }
  // O navegador pode restaurar a página pelo botão Voltar com o DOM em memória.
  window.addEventListener('pageshow', finalizarVisualPonte);

  async function lerCarrinho(){ const r=await fetch('/cart.js'); return r.json(); }
  function pegarUTMs(){ const a=new URLSearchParams(location.search),u=new URLSearchParams();
    for(const [k,v] of a.entries()) if(k.startsWith('utm_')) u.append(k,v); return u.toString(); }
  async function traduzirSKUs(skus){ const r=await fetch(CONFIG.endpointMapa,{method:'POST',
    headers:{'Content-Type':'application/json'},body:JSON.stringify({skus,destino:CONFIG.lojaMyshopify||CONFIG.lojaAntiga})});
    if(!r.ok) throw new Error('Servidor indisponivel.'); return r.json(); }
  let cache=null;
  const consultasMapaPonte=new Map();
  async function prep(){ try{ const c=await lerCarrinho(); if(!c.items||!c.items.length)return;
    const s=c.items.map(i=>i.sku).filter(Boolean); if(!s.length)return;
    await mapa(s); }catch(e){cache=null;} }
  async function mapa(s){ const k=[...s].sort().join('|');
    if(cache&&cache.k===k)return cache.m;
    if(consultasMapaPonte.has(k))return consultasMapaPonte.get(k);
    const pedido=traduzirSKUs(s).then(m=>{cache={k,m};return m;});
    consultasMapaPonte.set(k,pedido);
    try{return await pedido;}finally{if(consultasMapaPonte.get(k)===pedido)consultasMapaPonte.delete(k);} }

  async function ir(botao){
    if(ponteOcupada)return;
    ponteOcupada=true;
    let navegando=false;
    // Falhas no recurso visual não impedem a lógica original do checkout.
    try{restaurarBotaoPonte=prepararVisualPonte(botao);}catch(e){console.warn('[Ponte] Feedback visual indisponível.');}
    try{ const c=await lerCarrinho();
    if(!c.items||!c.items.length){alert('Seu carrinho esta vazio.');return;}
    const it=c.items.map(i=>({sku:i.sku,q:i.quantity,t:i.product_title}));
    const m=await mapa(it.map(i=>i.sku).filter(Boolean));
    const ok=[],fail=[];
    for(const i of it){ const id=i.sku?m[i.sku]:null; if(id)ok.push(id+':'+i.q); else fail.push(i.t); }
    if(!ok.length){alert('Nao foi possivel iniciar o checkout agora.');return;}
    if(fail.length&&!confirm('Itens indisponiveis serao removidos: '+fail.join(', ')+'. Continuar?'))return;
    let url=CONFIG.lojaAntiga+'/cart/'+ok.join(',');
    const p=new URLSearchParams(pegarUTMs());
    if(!CONFIG.irDiretoParaCheckout)p.set('storefront','true');
    try{const trace=window.__ponteFunil?.link(CONFIG.lojaMyshopify);if(trace)p.set('attributes[ponte_funnel]',trace);}catch{}
    const q=p.toString(); if(q)url+='?'+q;
    registrarRedirect(performance.now() - (window.__ponteT0 ?? performance.now()));
    location.href=url;
    navegando=true;
  }catch(e){console.error(e);alert('Problema ao iniciar o checkout. Tente novamente.');}
  finally{if(!navegando)finalizarVisualPonte();} }
  const SEL='[name="checkout"], .cart__checkout, a[href$="/checkout"]';
  function ehCheckout(f){ const a=f.getAttribute('action')||'';
    if(a.includes('/cart/add'))return false; return !!f.querySelector('[name="checkout"]'); }
  function instalar(){
    document.addEventListener('click',function(e){ const b=e.target.closest(SEL); if(!b)return;
      const f=b.closest('form'); if(f&&(f.getAttribute('action')||'').includes('/cart/add'))return;
      e.preventDefault();e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();if(!ponteOcupada){window.__ponteT0=performance.now();ir(b);} },true);
    document.addEventListener('submit',function(e){ const f=e.target;
      if(!f||f.tagName!=='FORM'||!ehCheckout(f))return;
      e.preventDefault();e.stopPropagation();if(e.stopImmediatePropagation)e.stopImmediatePropagation();if(!ponteOcupada){window.__ponteT0=performance.now();ir(e.submitter||f.querySelector('[name="checkout"]'));} },true);
    document.addEventListener('mouseenter',function(e){ const a=e.target;
      if(a&&typeof a.closest==='function'&&a.closest(SEL))prep(); },true);
  }
  document.addEventListener('DOMContentLoaded',function(){ instalar(); prep(); });
})();